import { render, staticRenderFns } from "./awaitDialog.vue?vue&type=template&id=3b40ec69&scoped=true"
import script from "./awaitDialog.vue?vue&type=script&lang=js"
export * from "./awaitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40ec69",
  null
  
)

export default component.exports